var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V20H0V0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00584412H30V5.30994H0V0.00584412ZM0 14.6959H30V20H0V14.6959Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000427246H30V20.0004H0V0.000427246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000427246H30V1.53844H0V0.000427246ZM0 3.07645H30V4.61446H0V3.07645ZM0 6.15247H30V7.69049H0V6.15247ZM0 9.2285H30V10.7665H0V9.2285ZM0 12.3104H30V13.8484H0V12.3104ZM0 15.3864H30V16.9244H0V15.3864ZM0 18.4624H30V20.0004H0V18.4624Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000427246H15V10.7665H0V0.000427246Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79532 8.12323L2.56141 7.37469L2.3041 8.12323H1.53217L2.1579 8.57353L1.92398 9.32206L2.56141 8.86007L3.18129 9.32206L2.94152 8.57353L3.57895 8.12323H2.79532ZM6.08772 8.12323L5.84796 7.37469L5.60234 8.12323H4.83041L5.45614 8.57353L5.22222 9.32206L5.84796 8.86007L6.47953 9.32206L6.24562 8.57353L6.87135 8.12323H6.08772ZM9.39182 8.12323L9.14035 7.37469L8.90643 8.12323H8.11696L8.76024 8.57353L8.51462 9.32206L9.14035 8.86007L9.78363 9.32206L9.53801 8.57353L10.1637 8.12323H9.39182ZM12.6784 8.12323L12.4444 7.37469L12.1988 8.12323H11.4211L12.0526 8.57353L11.8187 9.32206L12.4444 8.86007L13.076 9.32206L12.8246 8.57353L13.4678 8.12323H12.6784ZM5.84796 4.40393L5.60234 5.15247H4.83041L5.45614 5.61446L5.22222 6.3513L5.84796 5.89516L6.47953 6.3513L6.24562 5.61446L6.87135 5.15247H6.08772L5.84796 4.40393ZM2.56141 4.40393L2.3041 5.15247H1.53217L2.1579 5.61446L1.92398 6.3513L2.56141 5.89516L3.18129 6.3513L2.94152 5.61446L3.57895 5.15247H2.79532L2.56141 4.40393ZM9.14035 4.40393L8.90643 5.15247H8.11696L8.76024 5.61446L8.51462 6.3513L9.14035 5.89516L9.78363 6.3513L9.53801 5.61446L10.1637 5.15247H9.39182L9.14035 4.40393ZM12.4444 4.40393L12.1988 5.15247H11.4211L12.0526 5.61446L11.8187 6.3513L12.4444 5.89516L13.076 6.3513L12.8246 5.61446L13.4678 5.15247H12.6784L12.4444 4.40393ZM2.56141 1.44487L2.3041 2.18171H1.53217L2.1579 2.6437L1.92398 3.38639L2.56141 2.9244L3.18129 3.38639L2.94152 2.6437L3.57895 2.18171H2.79532L2.56141 1.44487ZM5.84796 1.44487L5.60234 2.18171H4.83041L5.45614 2.6437L5.22222 3.38639L5.84796 2.9244L6.47953 3.38639L6.24562 2.6437L6.87135 2.18171H6.08772L5.84796 1.44487ZM9.14035 1.44487L8.90643 2.18171H8.11696L8.76024 2.6437L8.51462 3.38639L9.14035 2.9244L9.78363 3.38639L9.53801 2.6437L10.1637 2.18171H9.39182L9.14035 1.44487ZM12.4444 1.44487L12.1988 2.18171H11.4211L12.0526 2.6437L11.8187 3.38639L12.4444 2.9244L13.076 3.38639L12.8246 2.6437L13.4678 2.18171H12.6784L12.4444 1.44487Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white",
    transform: "translate(0 0.000427246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnLanguage);
export default __webpack_public_path__ + "static/media/enLanguage.153bd23f87fdc8e0bb776ce647dfdce8.svg";
export { ForwardRef as ReactComponent };